<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <BaseCard
                        :loading-allowed="false"
                        :v-card-text-class="'pa-0'"
                        icon="mdi-filter-variant"
                        title="Employee Target Filter"
                    >
                        <v-form @submit.prevent="submit">
                            <v-row class="pa-2">
                                <v-col cols="12" lg="3" md="3" sm="6">
                                    <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="From Date"
                                        density="compact"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-calendar-month"
                                        single-line
                                        hide-details
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="from_date.value.value"
                                        :error-messages="from_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                    />
                                </v-col>

                                <v-col cols="12" lg="3" md="3" sm="6">
                                    <v-date-input
                                        input-format="dd/mm/yyyy"
                                        label="To Date"
                                        density="compact"
                                        single-line
                                        hide-details
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-calendar-month"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        v-model="to_date.value.value"
                                        :error-messages="to_date.errorMessage.value"
                                        autocomplete="off"
                                        clearable
                                    />
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-actions class="justify-end">
                                <v-btn
                                    ref="searchButton"
                                    class="bg-brand"
                                    prepend-icon="mdi-magnify"
                                    type="submit"
                                >
                                    Search
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </BaseCard>
                </v-col>

                <v-col cols="12">
                    <BaseCard
                        :loading-allowed="false"
                        :v-card-text-class="'pa-0'"
                        icon="mdi-clipboard-text-outline"
                        title="Employee Target List"
                    >
                        <v-row align="center" class="py-2 px-1">
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="search"
                                    append-inner-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    density="compact"
                                    variant="outlined"
                                    bg-color="grey-lighten-4"
                                    clearable
                                />
                            </v-col>

                            <v-col cols="12" md="4">
                                <div class="d-flex align-center flex-column">
                                    <v-btn-group
                                        variant="outlined"
                                        density="compact"
                                        size="small"
                                        divided
                                    >
                                        <v-btn
                                            prepend-icon="mdi-download"
                                            variant="flat"
                                            color="success"
                                            @click="exportToCSV"
                                        >
                                            CSV
                                        </v-btn>
                                        <v-btn
                                            prepend-icon="mdi-download"
                                            variant="flat"
                                            color="primary"
                                            @click="exportToExcel"
                                        >
                                            EXCEL
                                        </v-btn>
                                        <v-btn
                                            prepend-icon="mdi-download"
                                            variant="flat"
                                            color="red"
                                            @click="exportToPDF"
                                        >
                                            PDF
                                        </v-btn>
                                    </v-btn-group>
                                </div>
                            </v-col>

                            <v-col cols="12" md="4">
                                <div class="text-right pr-2">
                                    <v-btn
                                        v-if="$insertAccess($route.fullPath)"
                                        @click="goTo('/sales/add-employee-target')"
                                        color="primary"
                                        variant="tonal"
                                        prepend-icon="mdi-plus"
                                        rounded="xl"
                                    >
                                        Add EMPLOYEE target
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                        <v-data-table
                            :headers="headers"
                            :items="getSchema"
                            :loading="loading"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :hover="true"
                            density="compact"
                        >
                            <template v-slot:loader>
                                <v-progress-linear
                                    :color="loading"
                                    height="3"
                                    indeterminate
                                />
                            </template>

                            <template v-slot:item.index="{ index }">
                                {{ ++index }}
                            </template>

                            <template v-slot:item.type="{ item }">
                                {{ item.type.name }}
                            </template>

                            <template v-slot:item.approval_status_display="{ item }">
                                <v-chip
                                    v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                    color="yellow-darken-3"
                                    size="small"
                                >
                                    Wating for {{ item.approval_current_process.approval_step_name.name }}
                                </v-chip>

                                <v-chip
                                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                    color="green"
                                    size="small"
                                >
                                    Approved By {{ item.approval_current_process.approval_step_name.name }}
                                </v-chip>
                                <v-chip
                                    v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                    color="red"
                                    size="small"
                                >
                                    Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                </v-chip>
                                <v-chip
                                    v-else
                                    color="green"
                                    size="small"
                                >
                                    {{ item.approval_status }}
                                </v-chip>
                            </template>

                            <template v-slot:item.status="{ item }">
                                <v-chip
                                    v-if="item.status == 1"
                                    color="success"
                                    size="small"
                                    class="text-capitalize"
                                >Active</v-chip
                                >
                                <v-chip
                                    v-else
                                    color="red"
                                    size="small"
                                    class="text-capitalize"
                                >Inactive</v-chip
                                >
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-icon
                                    class="me-2"
                                    color="info"
                                    @click="viewItem(item)"
                                >
                                    mdi mdi-eye-outline
                                </v-icon>
                                <v-icon
                                    class="me-2 edit-button"
                                    color="primary"
                                    @click="editItem(item)"
                                >
                                    mdi mdi-pencil-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </BaseCard>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { ref } from "vue";
import { useField, useForm } from "vee-validate";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";
import BaseCard from "@/components/utils/baseCard.vue";

export default {
    components: {
        BaseCard
    },
    data: () => ({
        itemsPerPage: 10,
        search: "",
        dialog: false,
        data: {},
        headers: [
          { title: "#SL", align: "center", key: "index", width: "7%", sortable: false},
          { title: "Code", key: "code", align: "left", sortable: false },
          { title: "Employee", key: "employee.name", align: "left", sortable: false },
          { title: "Employee Code", key: "employee.code", align: "left", sortable: false },
          { title: "Start Date", key: "start_date", align: "left", sortable: false },
          { title: "End Date", key: "end_date", align: "left", sortable: false },
          { title: "Target Amount", key: "target_amount", align: "left", sortable: false },
          { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
          { title: "Status", align: "center", key: "status", sortable: true },
          { title: "Actions", align: "center", key: "actions", sortable: false },
        ],
    }),
    watch: {},
    created() {},
    computed: {
        getSchema() {
            const data = this.$store.getters.getSalesEmployeeTargetList;
            return Array.isArray(data) ? data : [];
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm();
        const from_date = useField("from_date");
        const to_date = useField("to_date");
        const errorMessages = ref("");
        const loading = ref('');
        const store = useStore();
        const submit = handleSubmit((values) => {
            loading.value = 'blue-darken-3';
            values.from_date = formattedDate(from_date.value.value);
            values.to_date = formattedDate(to_date.value.value);
            store
                .dispatch("getSalesEmployeeTargetList", values)
                .then((response) => {
                    loading.value = false;
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            from_date,
            to_date,
            errorMessages,
            submit,
            loading
        };
    },
    methods: {
        goTo(val) {
            this.$router.push({ path: val }).catch((err) => {});
        },

        editItem(item) {
            this.$store.commit("seteditingSalesEmployeeTarget", item);
            this.$router.push({
                name: "add-employee-target"
            });
        },

        viewItem(item) {
            this.$router.push({
                name: "sales-target-details",
                params: { id: item.id },
            });
        },

        exportToPDF() {
            let serialNumber = 1;
            const columns = [ "#SL", "Code", "Team Name","Department","Employee","Employee Code", "Period Type", "Start Date", "End Date","Target Amount", "Status"];

            const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.sales_team.team_name,item.department.name,item.employee.name,item.employee.code, item.period_type, item.start_date, item.end_date,item.target_amount, item.status == 1 ? "Active" : "Inactive"]);

            this.$exportTableToPDF(columns,rows,"Supplier List","supplier_list_" + this.$fileDate());
        },

        exportToExcel() {
            var data = [[ "#SL", "Code", "Team Name","Department","Employee","Employee Code", "Period Type", "Start Date", "End Date","Target Amount", "Status"]];

            var serialNumber = 1;

            this.getSchema.forEach((item) => { data.push([ serialNumber++, item.code, item.sales_team.team_name,item.department.name,item.employee.name,item.employee.code, item.period_type, item.start_date, item.end_date,item.target_amount, item.status == 1 ? "Active" : "Inactive", ]);
            });

            this.$exportTableToExcel(data, "supplier_list_" + this.$fileDate());
        },

        exportToCSV() {
            var data = [
                [ "#SL", "Code", "Team Name","Department","Employee","Employee Code", "Period Type", "Start Date", "End Date","Target Amount", "Status"]];
            var serialNumber = 1;

            this.getSchema.forEach((item) => { data.push([ serialNumber++, item.code, item.sales_team.team_name,item.department.name,item.employee.name,item.employee.code, item.period_type, item.start_date, item.end_date,item.target_amount, item.status == 1 ? "Active" : "Inactive" ]);
            });

            this.$exportTableToCSV(data, "supplier_list_" + this.$fileDate());
        },
    },
    mounted() {
        this.from_date.value.value = new Date();
        this.to_date.value.value = new Date();
        this.$nextTick(() => {
            this.$refs.searchButton.$el.click();
        });
    },
};
</script>
